import { FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import AdCard from "./AdCard";
import AdCardStudent from "./AdCardStudent";
import AdComments from "./AdComments";

const AdModal = ({
  show,
  ad,
  onClose,
  user,
  token,
  t,
  onAvatarClick,
  type = "tutor", // "tutor" or "student"
}) => {
  if (!show || !ad) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full relative"
        onClick={(e) => e.stopPropagation()}
        style={{ height: "99%", maxHeight: "99%" }}
      >
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
          onClick={onClose}
        >
          <FaTimes size={24} />
        </button>
        <div style={{ overflowY: "auto", height: "calc(99% - 40px)" }}>
          {/* Different ad info layouts */}
          {type === "student" ? (
            <AdCardStudent
              ad={ad}
              isViewScreen={true}
              onAdInfoClick={onAvatarClick}
            />
          ) : (
            <AdCard ad={ad} isViewScreen={true} onAvatarClick={onAvatarClick} />
          )}
          <div className="bg-white p-1 rounded shadow">
            {!token && (
              <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded flex items-center justify-between">
                <div className="text-sm text-yellow-800">
                  {t &&
                    t("loginRequired", { defaultValue: "請先登入以發表留言" })}
                </div>
                <div>
                  <Link
                    to="/login"
                    className="bg-yellow-600 text-white px-3 py-1 rounded"
                  >
                    {t ? t("login") : "登入"}
                  </Link>
                </div>
              </div>
            )}
            <AdComments
              adId={ad.id}
              adOwnerId={ad.userId}
              currentUser={user}
              token={token}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdModal;
